<div class="g-0">
    <div class="row">
        <div class="col">
            <div class="box-wrapper box-mesagerie">
                <div class="box-content-header">
                    <div class="row p-1">
                        <div class="col">
                            <mat-card-title>
                                <i class="fa-brands fa-rocketchat"></i>
                                <span>Mesagerie</span>
                            </mat-card-title>
                        </div>

                        <div class="col d-flex justify-content-end">
                            <div>
                                <mat-button-toggle-group name="fontStyle" aria-label="Font Style"
                                    (change)="onMessagingChange($event)" value="internalMsg">
                                    <mat-button-toggle value="internalMsg">Mesaj Intern</mat-button-toggle>
                                    <mat-button-toggle value="nota">Notă</mat-button-toggle>
                                </mat-button-toggle-group>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="box-content-body">
                    <div class="row p-2" *ngIf="selectedMessagingToggle == 'internalMsg'">
                        <div class="col">
                            <div class="fw-bold">Adăugați un mesaj</div>
                        </div>
                    </div>
                    <div class="row p-2" *ngIf="selectedMessagingToggle == 'nota'">
                        <div class="col">
                            <div class="fw-bold">Adăugați o notă</div>
                        </div>
                    </div>

                    <form [formGroup]="sendMessageInternForm" (ngSubmit)="submitMessage('intern')"
                        *ngIf="selectedMessagingToggle == 'internalMsg'">
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="sendMessageInternForm.get('message')?.touched && sendMessageInternForm.get('message')?.invalid">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="row px-2 pt-2">
                            <div class="col">
                                <mat-form-field class="w-100">
                                    <mat-label>Adaugă coleg</mat-label>
                                    <mat-chip-grid #chipGrid aria-label="Selectare colegi">
                                        <mat-chip-row *ngFor="let colleague of colleagues"
                                            (removed)="removeColleague(colleague)">
                                            {{ colleague.name }}
                                            <button class="colleague-chip-remove-icon" matChipRemove
                                                [attr.aria-label]="'remove ' + colleague.name">
                                                <mat-icon>cancel</mat-icon>
                                            </button>
                                        </mat-chip-row>
                                    </mat-chip-grid>
                                    <input placeholder="Coleg nou..." #colleagueInput [formControl]="colleaguesCtrl"
                                        [matChipInputFor]="chipGrid" [matAutocomplete]="auto"
                                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                        (matChipInputTokenEnd)="addColleague($event)" />
                                    <mat-autocomplete #auto="matAutocomplete"
                                        (optionSelected)="selectedColleagues($event)">
                                        <mat-option *ngFor="let colleague of filteredColleagues | async"
                                            [value]="colleague">
                                            {{ colleague.name }}
                                        </mat-option>
                                    </mat-autocomplete>
                                </mat-form-field>
                            </div>
                        </div>

                        <div class="solicitare-card__upload mx-2">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Fotografii/Documente</p>
                                <button class="upload-btn" (click)="fileInputIntern.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files" *ngIf="
                                sendMessageInternForm.value.files &&
                                sendMessageInternForm.value.files.length > 0 &&
                                !uploading.files_mesagerie_intern
                            ">
                                <div class="solicitare-card__upload-file" *ngFor="
                                        let uploadedFile of sendMessageInternForm.value.files;
                                        let i = index
                                    ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                        | slice : 0 : 30) + ".." : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div class="d-flex gap-4 align-items-center">
                                        <button class="solicitare-card__upload-file-view" type="button"
                                            matTooltip="Vizualizează fișierul" (click)="downloadTempFile(uploadedFile)">
                                            <mat-icon class="btn-icon">visibility</mat-icon>
                                            <span class="btn-text">Vizualizează</span>
                                        </button>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileIntern(i)">
                                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.files_mesagerie_intern"></mat-spinner>

                            <input type="file"
                                accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt"
                                id="files_mesagerie_intern" #fileInputIntern name="fileInputIntern"
                                (change)="addFileIntern($event, 'files_mesagerie_intern')" multiple
                                style="display: none" />
                        </div>

                        <div class="d-flex justify-content-end">
                            <button class="btn btn-light upload-btn m-3" type="submit"
                                [disabled]="sendMessageInternForm.invalid">
                                <span class="upload__text">TRIMITE</span>
                            </button>
                        </div>
                    </form>

                    <form [formGroup]="sendMessageNotitaForm" (ngSubmit)="submitMessage('nota')"
                        *ngIf="selectedMessagingToggle == 'nota'">
                        <div class="row">
                            <div class="col">
                                <angular-editor formControlName="message" [config]="editorConfig"></angular-editor>
                                <mat-error
                                    *ngIf="sendMessageNotitaForm.get('message')?.touched && sendMessageNotitaForm.get('message')?.invalid">
                                    Câmp obligatoriu
                                </mat-error>
                            </div>
                        </div>

                        <div class="solicitare-card__upload mx-2 mt-3">
                            <div class="solicitare-card__upload-header">
                                <p class="upload-text">Fotografii/Documente</p>
                                <button class="upload-btn" (click)="fileInputNotita.click()" type="button">
                                    <mat-icon class="upload-icon">cloud_upload</mat-icon>
                                    ÎNCARCĂ
                                </button>
                            </div>
                            <div class="solicitare-card__upload-files" *ngIf="
                                sendMessageNotitaForm.value.files &&
                                sendMessageNotitaForm.value.files.length > 0 &&
                                !uploading.files_mesagerie_notita
                            ">
                                <div class="solicitare-card__upload-file" *ngFor="
                                    let uploadedFile of sendMessageNotitaForm.value.files;
                                    let i = index
                                ">
                                    <span class="solicitare-card__upload-file-name">
                                        {{ uploadedFile.original_name.length > 30 ? (uploadedFile.original_name
                                        | slice : 0 : 30) + ".." : uploadedFile.original_name
                                        }}
                                    </span>
                                    <div class="d-flex gap-4 align-items-center">
                                        <button class="solicitare-card__upload-file-view" type="button"
                                            matTooltip="Vizualizează fișierul" (click)="downloadTempFile(uploadedFile)">
                                            <mat-icon class="btn-icon">visibility</mat-icon>
                                            <span class="btn-text">Vizualizează</span>
                                        </button>
                                        <button class="solicitare-card__upload-file-delete" type="button"
                                            matTooltip="Șterge fișierul încărcat" (click)="removeFileNota(i)">
                                            <img class="btn-img" src="/assets/icons/delete.svg" alt="" />
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <mat-spinner diameter="32" style="margin-right: 8px; margin-top: 4px"
                                *ngIf="uploading.files_mesagerie_notita"></mat-spinner>

                            <input type="file"
                                accept=".png, .jpg, .jpeg, .gif, .pdf, .doc, .docx, .xls, .xlsx, .ods, .odt"
                                id="files_mesagerie_notita" #fileInputNotita name="fileInputNotita"
                                (change)="addFileNotita($event, 'files_mesagerie_notita')" multiple
                                style="display: none" />
                        </div>

                        <div class="d-flex justify-content-end">
                            <button class="btn btn-light upload-btn m-3" type="submit"
                                [disabled]="sendMessageNotitaForm.invalid">
                                <span class="upload__text">TRIMITE</span>
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            <div class="section-spinner position-fixed" *ngIf="isLoading">
                <div class="spinner position-absolute top-50 start-50 translate-middle">
                    <mat-spinner></mat-spinner>
                    <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
                </div>
            </div>
        </div>
    </div>
</div>